import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Package } from 'lucide-react';
import { useToast } from './Toast';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const AmmoSalesHeader = () => {
  const toast = useToast();
  const [sales, setSales] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTagFilter, setSelectedTagFilter] = useState('ALLE');
  const [availableTags, setAvailableTags] = useState(['MEDLEM', 'SIKKERH.KURS', 'PRØVESKYTING', 'INNSKYTING']);

  useEffect(() => {
    fetchTags();
    fetchSales();
  }, []);

  const fetchTags = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE}/api/admin/ammo-settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAvailableTags(response.data.ammo_tags || ['MEDLEM', 'SIKKERH.KURS', 'PRØVESKYTING', 'INNSKYTING']);
    } catch (error) {
      console.error('Error fetching tags:', error);
    }
  };

  const fetchSales = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE}/api/admin/ammo-sales?limit=500`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSales(response.data.sales || []);
    } catch (error) {
      console.error('Error fetching ammo sales:', error);
    }
  };

  // Share filter state with AmmoSalesList via localStorage or context
  useEffect(() => {
    localStorage.setItem('ammoSalesSearchTerm', searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    localStorage.setItem('ammoSalesTagFilter', selectedTagFilter);
  }, [selectedTagFilter]);

  return (
    <div className="space-y-4">
      {/* Search and Tag Filters */}
      <div className="space-y-4">
        <input
          type="text"
          placeholder="Søk etter medlem eller kaliber..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 bg-gray-700 border border-gray-600 rounded text-white placeholder-gray-400"
        />
        
        {/* Quick Tag Filters */}
        <div>
          <p className="text-sm text-gray-400 mb-2">Hurtigfilter - Kategori:</p>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setSelectedTagFilter('ALLE')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                selectedTagFilter === 'ALLE'
                  ? 'bg-yellow-500 text-gray-900'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
              }`}
            >
              ALLE
            </button>
            {availableTags.map((tag) => (
              <button
                key={tag}
                onClick={() => setSelectedTagFilter(tag)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedTagFilter === tag
                    ? 'bg-yellow-500 text-gray-900'
                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-gray-700 rounded-lg">
          <div className="flex items-center gap-2 text-gray-400 text-sm mb-1">
            <Package className="h-4 w-4" />
            <span>Totalt antall salg</span>
          </div>
          <p className="text-2xl font-bold text-white">{sales.length}</p>
        </div>
        <div className="p-4 bg-gray-700 rounded-lg">
          <div className="flex items-center gap-2 text-gray-400 text-sm mb-1">
            <Package className="h-4 w-4" />
            <span>Totalt esker solgt</span>
          </div>
          <p className="text-2xl font-bold text-white">
            {sales.reduce((sum, s) => sum + s.boxes_sold, 0)}
          </p>
        </div>
        <div className="p-4 bg-gray-700 rounded-lg">
          <div className="flex items-center gap-2 text-gray-400 text-sm mb-1">
            <span>💰</span>
            <span>Total omsetning</span>
          </div>
          <p className="text-2xl font-bold text-yellow-400">
            {Math.round(sales.reduce((sum, s) => sum + s.total_amount, 0))} kr
          </p>
        </div>
      </div>
    </div>
  );
};

export default AmmoSalesHeader;
